import React, { FC, useMemo } from "react";
import { Link } from "react-router-dom";
import { Restriction } from "../../../lmsApi/restriction/restriction";
import { RestrictionService } from '../../../lmsApi/restriction/service';
import TableComponent from "../../../component/table/tableComponent";
import { ErrorHandler } from "../../../service/errorHandler";
import { TableLoadData, HeaderItem, TableRowAction, TableGroupAction } from "../../../component/table/tableComponent/types";

interface IProps {
    filterValues?: { [key: string]: any }
}

const RestrictionTable: FC<IProps> = (props) => {
    const header = useMemo<HeaderItem[]>(() => [
        {
            textId: 'main:field-id',
            field: 'id',
            sortable: true,
            getCellObject: (item: Restriction) => {
                return (<td className="align-middle">{item.id}</td>);
            }
        },
        {
            textId: 'restriction:name',
            field: 'name',
            alwaysVisible: true,
            getCellObject: (item: Restriction) => {
                return (
                    <td className="align-middle">
                        <Link className="link-hover" to={RestrictionService.getDetailLink(item)}>{item.name}</Link>
                    </td>
                );
            }
        },
        {
            textId: 'restriction:code',
            field: 'code',
            getCellObject: (item: Restriction) => {
                return (
                    <td className="align-middle">{item.code}</td>
                );
            }
        }
    ], []);

    const rowActions = useMemo<TableRowAction[]>(() => [
        {
            textId: 'main:btn-delete',
            action: (e: React.SyntheticEvent, item: Restriction) => clickDelete(e, [item.id])
        }
    ], []);

    const groupActions = useMemo<TableGroupAction[]>(() => [
        {
            id: 'delete',
            textId: 'main:btn-delete',
            action: (e: React.SyntheticEvent, selected: string[]) => clickDelete(e, selected.map(x => Number(x)))
        }
    ], []);

    const loadData = async (data: TableLoadData) => {
        var requestData = {
            order: { [data.sortBy]: data.sortOrder.toUpperCase() },
            filter: { ...data.filterValues },
            skip: data.skip,
            take: data.take
        };
        const result = await RestrictionService.list(requestData);
        return result;
    }

    const clickDelete = async (e: React.SyntheticEvent, ids: number[]) => {
        try {
            if (e) e.preventDefault();
            await RestrictionService.delete(ids);
        }
        catch (err) {
            ErrorHandler.handle('delete restrictions', err);
        }
    }

    return (
        <TableComponent id="restriction-table-component" filterValues={props.filterValues} defaultVisibleColumns={['id', 'name', 'code']} header={header}
            loadData={loadData} rowActions={rowActions} groupActions={groupActions} />
    );
}

export default RestrictionTable;
